var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPhotos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_photos_svg__clip0)",
    stroke: "#FF6459",
    strokeWidth: 1.25
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 7,
    width: 42,
    height: 34,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 16,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.36 41L12.173 15.813a.5.5 0 00-.707 0L3 24.279"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 31.64l-6.827-6.827a.5.5 0 00-.707 0L29 33.279"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_photos_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwKSI+CjxyZWN0IHg9IjMiIHk9IjciIHdpZHRoPSI0MiIgaGVpZ2h0PSIzNCIgcng9IjAuNSIgc3Ryb2tlPSIjRkY2NDU5IiBzdHJva2Utd2lkdGg9IjEuMjUiLz4KPGNpcmNsZSBjeD0iMzEiIGN5PSIxNiIgcj0iMyIgc3Ryb2tlPSIjRkY2NDU5IiBzdHJva2Utd2lkdGg9IjEuMjUiLz4KPHBhdGggZD0iTTM3LjM2MDQgNDFMMTIuMTczNCAxNS44MTNDMTEuOTc4MSAxNS42MTc4IDExLjY2MTUgMTUuNjE3OCAxMS40NjYzIDE1LjgxM0wzIDI0LjI3OTMiIHN0cm9rZT0iI0ZGNjQ1OSIgc3Ryb2tlLXdpZHRoPSIxLjI1Ii8+CjxwYXRoIGQ9Ik00NSAzMS42Mzk2TDM4LjE3MzQgMjQuODEzQzM3Ljk3ODEgMjQuNjE3OCAzNy42NjE1IDI0LjYxNzggMzcuNDY2MyAyNC44MTNMMjkgMzMuMjc5MyIgc3Ryb2tlPSIjRkY2NDU5IiBzdHJva2Utd2lkdGg9IjEuMjUiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMCI+CjxyZWN0IHdpZHRoPSI0OCIgaGVpZ2h0PSI0OCIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";
export { SvgIconPhotos as ReactComponent };